module.exports = __webpack_public_path__ + "img/trunk_10x3.0f0d44ca.svg";